import "./dashboard.scss";
import React, { useState, useEffect, useRef, Suspense, lazy } from "react";
import locaibrary from "../../assets/card/assignment.svg";
import {
  ORG_ID,
  GRID_DEFAULT_PAGE_SIZE,
  USER_ID,
  API_STATUS,
  SERVICE_TYPE,
  ROW_PER_PAGE_SIZE,
  SW_CLIENT_MANAGER,
  SW3RD_PARTY_INSPECTOR,
} from "../../constant/constant";
import { useLocation, useNavigate } from "react-router-dom";
import * as swInspectionAction from "../../redux/storm-water/actions/swInspectionAction";
import {
  DASHBOARD,
  SW_INSPECTION_ADD,
  SW_OPEN_ITEMS,
  SW_INSPECTION_VIEW,
  LANDING_PAGE,
  ADMIN_ADD_NEWS,
  ADMIN_LIST_NEWS,
  SW_INSPECTION_PROOF,
  SW_DAILY_REPORT,
  SW_INSPECTION_LIST,
  ADMIN_ADD_STORM_WATERPROJECT,
  SWDASHBOARD,
} from "../../constant/routeContant";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box, Grid, Popover, Typography } from "@mui/material";
import Button from "../../library/custom/button/Button";
import GridTable from "../../library/custom/gridTable/GridTable";
import SettingTable from "../incidents/incidentList/SettingTable";
import ReportRowManipulte from "../incidents/incidentList/ReportRowManipulte";
import { TableLoader } from "../../library/common/Loader";
import NORow from "../../library/custom/noRow/noRow";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import TextArea from "../../library/custom/textArea/TextArea";
import SelectMenu from "../../library/custom/selectMenu/SelectMenu";
import FormControl from "@mui/material/FormControl";
import FormLabels from "../../library/custom/formLabel/FormLabels";
import {
  convertToISODate,
  getCurrentDate,
  InactiveClient,
  twoDigitAfterDecimal,
  getFormatedDate,
  formatRainfallValue,
} from "../../utils/helper";
import { checkPrivileges, hasAllPrivileges } from "../../utils/rolesHelper";
import tableImg from "../../assets/humidity_mid.svg";
import tableImgDark from "../../assets/humidity_mid_dark.svg";
import SiteProjectHeader from "../storm-water/admin/components/siteProjectHeader";
import { PRODUCT_ID } from "../../constant/storm-water/constant";
import * as swCommonAction from "../../redux/storm-water/actions/swCommonAction";
import * as newsAction from "../../redux/actions/newsAction";
import customizeDashIcon from "../../assets/info.svg";
import Loader from "../../library/common/Loader";
import { useThemeContext } from "../../context";
import Buttons from "../../library/custom/button/Button";
import { ToastContainer } from "react-toastify";
import tableCancel from "../../assets/sw_error.svg";
import SearchIcon from "@mui/icons-material/Search";
import DialogBox from "../../library/common/DialogBox";
import { useDebounce } from "../../utils/useDebounceSearch";
const NewsList = lazy(() => import("../admin/component/news/listNews"));
const SwDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedCardId = location?.state?.cartid ?? 1;
  const { mode } = useThemeContext();

  const CHECK_PRE =
    !hasAllPrivileges(SW_CLIENT_MANAGER) &&
    !hasAllPrivileges(SW3RD_PARTY_INSPECTOR);

  const preservedState = useRef(
    (() => {
      const shouldPreserve =
        sessionStorage.getItem("swDashboardPreserveState") === "true";
      if (!shouldPreserve) return null;
      try {
        const filterObj = JSON.parse(
          sessionStorage.getItem("swDashboardFilterObj") || "null",
        );
        return filterObj;
      } catch {
        return null;
      }
    })(),
  );

  const isCartIsteamInitial = useRef(true);
  const isSearchInitial = useRef(true);

  const [open, setOpen] = React.useState(false);
  const [page, setPage] = useState(() => {
    if (preservedState.current) {
      return preservedState.current.page || 0;
    }
    return 0;
  });
  const [cart, setCart] = React.useState(() => {
    if (preservedState.current) {
      return preservedState.current.cart || selectedCardId || 1;
    }
    return selectedCardId || 1;
  });
  const [ismissedOrDiffer, setismissedOrDiffer] = useState("");
  const [isReasondiff, setisReasondiff] = useState(false);
  const [isteam, setisteam] = useState(() => {
    if (preservedState.current) {
      return preservedState.current.isteam || false;
    }
    return false;
  });
  const [isteamval, setisteamval] = useState(() => {
    if (preservedState.current) {
      return preservedState.current.isteam ? 2 : 1;
    }
    return 1;
  });
  const [pageSize, setPageSize] = useState(() => {
    if (preservedState.current) {
      return preservedState.current.pageSize || GRID_DEFAULT_PAGE_SIZE;
    }
    return GRID_DEFAULT_PAGE_SIZE;
  });
  const [search, setSearch] = useState(() => {
    if (preservedState.current) {
      return preservedState.current.search || "";
    }
    return "";
  });
  const [isTableLoading, setisTableLoading] = useState(false);
  const [cusid, setcusid] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [deleteSelectedRow, setDeleteSelectedRow] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const debouncedSearch = useDebounce(search, 600);

  const handleIconClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose1 = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const open1 = Boolean(anchorEl);

  const [deffswInsData, setDeffswInsData] = useState({
    inspectionId: "",
    isMissedDeferral: "",
    deferralReasonId: "",
    comment: "",
    userId: 0,
  });

  const [otherDroupdownKey, setOtherDroupdownKey] = useState("");
  const adminView = checkPrivileges([12]);
  const areaView = checkPrivileges([136, 137]);
  // for Service Type code
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const userInfoProduct = userInfo?.product;
  const data = userInfoProduct?.map((val) => val?.key);
  const getSwReference = useSelector((state) => state.getSwReference);
  const getNewsList = useSelector((state) => state?.getNewsList);
  const deleteReportData = useSelector((state) => state.deleteSwInspection);

  const NewsData = getNewsList?.data?.news;

  useEffect(() => {
    sessionStorage.removeItem("swDashboardPreserveState");
    sessionStorage.removeItem("swDashboardFilterObj");
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    const defaultData = {
      page: 1,
      pageSize: 2,
    };
    dispatch(newsAction.getNewsList(defaultData));
  }, []);

  useEffect(() => {
    if (PRODUCT_ID() == 1) {
      navigate(DASHBOARD);
    }

    if (SERVICE_TYPE() == null && data?.length > 1) {
      navigate(LANDING_PAGE);
    }
  }, []);

  const getDashboardcarddetails = useSelector(
    (state) => state.swDashboardcardDetails,
  );
  const DashboardcarddetailsData = getDashboardcarddetails?.data;

  const deferredSwInspectionData = useSelector(
    (state) => state.deferredSwInspection,
  );
  const deffInspecrtion_status = deferredSwInspectionData?.status;
  const deffInspecrtion_Isloading = deferredSwInspectionData?.isLoading;

  const todayInspectionCount = DashboardcarddetailsData?.todayInspectionCount;
  const pastDueinspectionCount =
    DashboardcarddetailsData?.pastDueinspectionCount;
  const draftCount = DashboardcarddetailsData?.draftCount;

  const openItemCount = DashboardcarddetailsData?.openItemCount;
  const IsLoadings = getDashboardcarddetails?.isLoading;
  const deleteReportLoading = useSelector(
    (state) => state.deleteSwInspection?.isLoading,
  );

  const defaulydata1 = {
    userId: areaView
      ? parseInt(USER_ID())
      : adminView
        ? ""
        : parseInt(USER_ID()),
    organizationId: ORG_ID(),
    page: page + 1,
    pageSize: pageSize,
    cartType: cart,
    isTeamTask: isteam,
    search: search ? search : "",
  };
  useEffect(() => {
    if (deffInspecrtion_status == API_STATUS.SUCCESS) {
      swDashboardcardDetail(defaulydata1);
      setOpen(false);
      setisReasondiff(false);
    }
  }, [deferredSwInspectionData]);

  useEffect(() => {
    if (deleteReportData?.status === API_STATUS.SUCCESS) {
      swDashboardcardDetail(defaulydata1);
    }
  }, [deleteReportData]);

  useEffect(() => {
    if (preservedState.current) {
      const savedData = {
        userId: areaView
          ? parseInt(USER_ID())
          : adminView
            ? ""
            : parseInt(USER_ID()),
        organizationId: ORG_ID(),
        page: preservedState.current.page + 1,
        pageSize: preservedState.current.pageSize,
        cartType: preservedState.current.cart,
        isTeamTask: preservedState.current.isteam || false,
        search: preservedState.current.search || "",
      };
      swDashboardcardDetail(savedData);
      preservedState.current = null;
    } else {
      const defaulydata2 = {
        userId: areaView
          ? parseInt(USER_ID())
          : adminView
            ? ""
            : parseInt(USER_ID()),
        organizationId: ORG_ID(),
        page: 1,
        pageSize: pageSize,
        cartType: cart,
        isTeamTask: isteam,
        search: search ? search : "",
      };
      swDashboardcardDetail(defaulydata2);
    }
  }, []);

  useEffect(() => {
    if (isCartIsteamInitial.current) {
      isCartIsteamInitial.current = false;
      return;
    }
    setPage(0);
    const defaulydata2 = {
      userId: areaView
        ? parseInt(USER_ID())
        : adminView
          ? ""
          : parseInt(USER_ID()),
      organizationId: ORG_ID(),
      page: 1,
      pageSize: pageSize,
      cartType: cart,
      isTeamTask: isteam,
      search: search ? search : "",
    };
    swDashboardcardDetail(defaulydata2);
  }, [cart, isteam]);
  function swDashboardcardDetail(defaulydata1) {
    dispatch(
      swInspectionAction.getSwDashboardCardDetailsInspection(defaulydata1),
    );
  }
  const swDeferredInspection = (data) => {
    dispatch(swInspectionAction.deferredSwInspection(data));
  };

  const DeferInspectionOnClick = (rows, val) => {
    if (InactiveClient()) return;
    setismissedOrDiffer(val);
    setisReasondiff(false);
    setOpen(true);
    setDeffswInsData({
      ...deffswInsData,
      inspectionId: rows?.row?.reportId,
      isMissedDeferral: val === 2 ? false : true,
      deferralReasonId: "",
      comment: "",
      userId: USER_ID(),
    });
  };

  const deferralSwInspectionSubmit = (data) => {
    if (InactiveClient()) return;
    let errors = false;

    if (deffswInsData?.deferralReasonId == "") {
      setisReasondiff(true);
      errors = true;
    }

    if (!errors) {
      swDeferredInspection(deffswInsData);
    }
  };
  const refData = {
    flags: [7],
  };
  const getSwReferenceData = (data) => {
    dispatch(swCommonAction.getSwReference(data));
  };

  useEffect(() => {
    getSwReferenceData(refData);
  }, []);
  const regAgencyData = getSwReference?.data?.reasonForDeferralList;

  useEffect(() => {
    const updateList = regAgencyData?.filter(
      (list) => list?.value?.toLowerCase() === "other",
    );
    if (updateList?.length > 0) {
      setOtherDroupdownKey(updateList[0]?.key);
    }
  }, [regAgencyData]);

  const handleEditOnClick = (row) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("swDashboardPreserveState", "true");
    sessionStorage.setItem(
      "swDashboardFilterObj",
      JSON.stringify({
        page: page,
        pageSize: pageSize,
        search: search,
        cart: cart,
        isteam: isteam,
      }),
    );
    navigate(SW_INSPECTION_ADD, {
      state: {
        row: row,
        editMode: true,
      },
    });
  };
  const editProjectOnClick = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("swDashboardPreserveState", "true");
    sessionStorage.setItem(
      "swDashboardFilterObj",
      JSON.stringify({
        page: page,
        pageSize: pageSize,
        search: search,
        cart: cart,
        isteam: isteam,
      }),
    );
    navigate(ADMIN_ADD_STORM_WATERPROJECT, {
      state: {
        projectid: rows.projectId,
        customerId: rows.customerId,
        customerName: rows.customer,
        editMode: true,
        stateId: rows.stateId,
        clients: rows?.customerId,
        projectNumber: rows?.projectNumber,
        projectName: rows?.name,
        route: SWDASHBOARD,
        routeText: "Back to Dashboard",
      },
    });
  };
  const handleViewOnClick = (row) => {
    sessionStorage.setItem("swDashboardPreserveState", "true");
    sessionStorage.setItem(
      "swDashboardFilterObj",
      JSON.stringify({
        page: page,
        pageSize: pageSize,
        search: search,
        cart: cart,
        isteam: isteam,
      }),
    );
    navigate(SW_INSPECTION_VIEW, {
      state: {
        inspectionId: row?.reportId,
        customerId: row?.customerId,
      },
    });
  };

  const conductExternalOnClick = (row) => {
    if (InactiveClient()) return;
    window.open(row?.externalFormUrl, "_blank")?.focus();
  };
  const addProofOnClick = (row) => {
    sessionStorage.setItem("swDashboardPreserveState", "true");
    sessionStorage.setItem(
      "swDashboardFilterObj",
      JSON.stringify({
        page: page,
        pageSize: pageSize,
        search: search,
        cart: cart,
        isteam: isteam,
      }),
    );
    navigate(SW_INSPECTION_PROOF, {
      state: {
        inspectionId: row?.reportId,
      },
    });
  };

  const handleAddOnClick = (row) => {
    sessionStorage.setItem("swDashboardPreserveState", "true");
    sessionStorage.setItem(
      "swDashboardFilterObj",
      JSON.stringify({
        page: page,
        pageSize: pageSize,
        search: search,
        cart: cart,
        isteam: isteam,
      }),
    );
    if (row?.questionSetId === 0 && !row?.isExternal) {
      if (InactiveClient()) return;
      navigate(SW_DAILY_REPORT, {
        state: {
          row: row,
        },
      });
    } else {
      if (InactiveClient()) return;
      navigate(SW_INSPECTION_ADD, {
        state: {
          row: row,
          addMode: true,
          addDirectInspection: false,
        },
      });
    }
  };

  const handleDeleteOnClick = (data) => {
    dispatch(swInspectionAction.deleteSwInspection(data));
  };

  const deleteReport = (report) => {
    if (InactiveClient()) return;
    const customerId = report?.customerId;
    const reportId = report?.reportId;
    setcusid(customerId);
    setOpenModal(true);
    setDeleteSelectedRow(reportId);
  };

  const deletehandle = () => {
    setOpenModal(false);
    const swinsreportdata = {
      selectedRow: deleteSelectedRow,
      cusid,
    };
    handleDeleteOnClick(swinsreportdata);
  };
  const columns = [
    // {
    //   field: "projectNumber",
    //   headerName: "Project No.",
    //   flex: 0.7,
    //   hide: false,
    // },
    {
      field: "customer",
      headerName: "Client",
      flex: 1.5,
      hide: false,
      renderCell: (cellValues) => {
        return (
          <>
            <div className="swdashCustomer">
              <div className="sw-customer">{cellValues?.value}</div>
            </div>
          </>
        );
      },
    },
    {
      field: "projectName",
      headerName: "Project",
      flex: 1.5,
      hide: false,
      renderCell: (cellValues) => {
        return (
          <>
            <div className="swdashCustomer">
              <div className="sw-sample-icon">
                {cellValues?.row?.sampleRequired ? (
                  <div>
                    {" "}
                    <img
                      src={mode === "dark" ? tableImgDark : tableImg}
                      alt=""
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="sw-customer">{cellValues?.value}</div>
            </div>
          </>
        );
      },
    },
    {
      field: "dateSchedule",
      headerName: "Date Scheduled",
      flex: 1.0,
      hide: false,
    },
    {
      field: "frequency",
      headerName: "Frequency",
      flex: 0.8,
      hide: false,
      renderCell: (rows) => {
        return (
          <>
            <div>
              {rows?.row?.questionSetId === 0 && !rows?.row?.isExternal ? (
                "Daily Report"
              ) : (
                <>
                  {rows?.row?.frequency}{" "}
                  {rows?.row?.frequencyId === 5 &&
                  rows?.row?.isFluid &&
                  rows?.row?.insTerm
                    ? `(${rows?.row?.insTerm})`
                    : ""}
                  {rows?.row?.frequencyId === 7 ? (
                    <span
                      className="frequencyInDays"
                      title={rows?.row?.frequencyInDays}
                    >
                      {"- " + rows?.row?.frequencyInDays}
                    </span>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </>
        );
      },
    },
    { field: "openItems", headerName: "Open Items", flex: 0.6, hide: false },
    {
      field: "assignedInspectorName",
      headerName: "Inspector Name",
      flex: 0.9,
      hide: true,
    },
    {
      field: "inspectionType",
      headerName: "Inspection Type",
      flex: 0.9,
      hide: false,
    },
    {
      field: "rainfall",
      headerName: "Rainfall",
      flex: 0.7,
      hide: false,
      renderCell: (rows) => {
        return (
          <>
            {/* <div>
              {rows?.row?.rainfall === null
                ? "N/A"
                : twoDigitAfterDecimal(rows?.row?.rainfall)}
            </div> */}

            <div className="swdashCustomer_rainfallEvnt">
              <div className="rfEventAmt_div">
                {rows?.row?.rainfall === null
                  ? "N/A"
                  : formatRainfallValue(rows?.row?.rainfall)}
              </div>
              <div
                className="sw-sample-icon_tool_tip"
                onClick={(e) => handleIconClick(e, rows)}
              >
                <div>
                  <img
                    src={mode === "dark" ? tableImgDark : tableCancel}
                    alt=""
                  />
                </div>
              </div>
              {rows?.row?.isRaining && (
                <div className="sw-sample-icon_tool_tip">
                  <div>
                    <svg
                      fill={mode === "dark" ? "#ffffff" : "#1b436e"}
                      version="1.1"
                      id="Capa_1"
                      width="20px"
                      height="20px"
                      viewBox="0 0 514.8 514.8"
                    >
                      <g>
                        <path
                          d="M405.962,47.612c-7.037,0-13.674,1.597-19.688,4.312c-12.021-23.963-36.749-40.459-65.389-40.459
		c-18.628,0-35.582,7.019-48.501,18.484C250.658,11.398,221.961,0,190.396,0C123.573,0,69.344,50.614,67.967,113.517
		c-25.054,11.628-42.458,36.93-42.458,66.354c0,34.004,23.228,62.52,54.669,70.724l338.579,2.324
		c39.178-1.405,70.533-33.526,70.533-73.048c0-28.219-15.988-52.661-39.388-64.872c2.61-5.929,4.121-12.441,4.121-19.335
		C454.024,69.127,432.508,47.612,405.962,47.612z"
                        />
                        <path
                          d="M141.818,372.364c8.501-16.438,9.524-91.36,9.524-91.36s-60.55,44.141-69.051,60.578
		c-8.501,16.438-2.065,36.653,14.373,45.154C113.102,395.237,133.317,388.802,141.818,372.364z"
                        />
                        <path
                          d="M266.13,372.364c8.501-16.438,9.524-91.36,9.524-91.36s-60.55,44.141-69.051,60.578
		c-8.501,16.438-2.065,36.653,14.372,45.154C237.414,395.237,257.629,388.802,266.13,372.364z"
                        />
                        <path
                          d="M354.861,386.736c16.438,8.501,36.653,2.065,45.154-14.372c8.501-16.438,9.524-91.36,9.524-91.36
		s-60.55,44.141-69.051,60.578C331.988,358.021,338.423,378.235,354.861,386.736z"
                        />
                        <path
                          d="M125.361,511.049c16.438,8.501,36.653,2.065,45.154-14.372c8.501-16.438,9.524-91.36,9.524-91.36
		s-60.549,44.141-69.051,60.578C102.487,482.333,108.923,502.548,125.361,511.049z"
                        />
                        <path
                          d="M249.673,511.049c16.438,8.501,36.653,2.065,45.154-14.372c8.501-16.438,9.524-91.36,9.524-91.36
		s-60.55,44.141-69.051,60.578C226.8,482.333,233.235,502.548,249.673,511.049z"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </>
        );
      },
    },

    {
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={DashboardcarddetailsData?.listDetails?.length ?? 0}
          numberOfItemsPerPage={pageSize}
          incidentLists={DashboardcarddetailsData?.listDetails ?? []}
          fileNameXL={"SwInspectionList"}
        />
      ),
      width: 65,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        const currentDate = new Date(getCurrentDate());
        const row = rows && rows.row;

        const dateScheduleString = row?.dateSchedule;
        const formattedDateSchedule = dateScheduleString
          ? convertToISODate(dateScheduleString)
          : null;
        const dateSchedule = new Date(formattedDateSchedule);

        const isDeferVisible =
          row?.isFluid && row?.deferredCount >= 2
            ? false
            : dateSchedule <= currentDate &&
              row?.statusId !== 1 &&
              row?.frequencyId !== 1 &&
              (row?.frequencyId !== 5 || !row?.insTerm) &&
              checkPrivileges([12, 136, 137]);

        const isMissedVisible =
          row?.isFluid && row?.deferredCount >= 2
            ? false
            : dateSchedule < currentDate &&
              row?.statusId !== 1 &&
              row?.frequencyId !== 1 &&
              (row?.frequencyId !== 5 || !row?.insTerm) &&
              checkPrivileges([12, 136, 137]);

        const isAddButtonVisible =
          !row?.isExternal &&
          row?.statusId === 8 &&
          dateSchedule <= currentDate;

        const addButtonLabel =
          row?.questionSetId === 0 && !row?.isExternal
            ? "Add Report"
            : "Add Inspection";

        const isEditVisible = !row?.isExternal && row?.statusId === 1;
        const isViewVisible = !row?.isExternal && row?.statusId === 1;

        const canConductExternal = row?.isExternal && row?.statusId === 8;

        return (
          <ReportRowManipulte
            rows={rows}
            defer={isDeferVisible}
            deferOnClick={() => DeferInspectionOnClick(rows, 2)}
            deferLabel="Defer Inspection"
            missed={isMissedVisible}
            missedOnClick={() => DeferInspectionOnClick(rows, 1)}
            missedLabel="Missed Deferral"
            addBtn={isAddButtonVisible}
            addBtnLabel={addButtonLabel}
            addForm={() => handleAddOnClick(row)}
            edit={isEditVisible}
            editLabel="Edit Inspection"
            editOnClick={() => handleEditOnClick(row)}
            view={isViewVisible}
            viewLabel="View Inspection"
            viewOnClick={() => handleViewOnClick(row)}
            conductExternal={canConductExternal}
            conductExternalOnClick={() => conductExternalOnClick(row)}
            conductExternalLabel="Conduct Inspection"
            addProof={canConductExternal}
            addProofOnClick={() => addProofOnClick(row)}
            addProofLabel="Certify Completion"
            deleted={
              row?.statusId === 1 && checkPrivileges([12, 136, 137, 138, 102])
            }
            deleteOnClick={deleteReport}
            deleteLabel={"Delete Inspection"}
            editProject={checkPrivileges([12, 111, 112, 113])}
            editProjectOnClick={editProjectOnClick}
            editProjectLabel={"Manage Project"}
          />
        );
      },
    },
  ];

  if (checkPrivileges([136, 137]) && isteamval === 2) {
    columns.find((column) => column.field === "assignedInspectorName").hide =
      false;
  }

  const inspectionduedashboard = (id) => {
    if (cart !== id) {
      setCart(id);
      setSearch("");
      setPage(0);
      setPageSize(GRID_DEFAULT_PAGE_SIZE);
    }
  };

  const getRowClassName = (params) => {
    const { rainEventId, isFluid, frequencyId, insTerm, statusId } =
      params.row || {};

    const current = new Date(getCurrentDate(true));
    const scheduledDate = params.row?.dateSchedule
      ? new Date(params.row.dateSchedule)
      : null;

    // --- 1. Draft rows always take priority ---
    if (statusId === 1) {
      return "highlight-post-Draft";
    }

    // --- 2. Validate scheduled date before comparing ---
    if (!scheduledDate || isNaN(scheduledDate)) return "";

    const isRainEvent = rainEventId && rainEventId > 0;
    const noRainEvent = !rainEventId || rainEventId === 0;

    // --- 3. Missed inspection for rain events (deadline = next-day 23:59:59) ---
    if (isRainEvent) {
      const nextDayDeadline = new Date(scheduledDate);
      nextDayDeadline.setDate(nextDayDeadline.getDate() + 1);
      nextDayDeadline.setHours(23, 59, 59, 999);

      if (current > nextDayDeadline) {
        return "highlight-post-missedInspection";
      }
    }

    // --- 4. Fluid weekly inspections (Friday & Saturday logic) ---
    if (
      noRainEvent &&
      isFluid &&
      frequencyId === 5 &&
      insTerm === "1" && // added correctly here
      scheduledDate < current &&
      (current.getDay() === 5 || current.getDay() === 6)
    ) {
      return "highlight-post-missedInspection";
    }

    // --- 5. Generic missed inspection ---
    if (noRainEvent && scheduledDate < current && statusId !== 1) {
      return "highlight-post-missedInspection";
    }

    return "";
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);

    const data = {
      userId: areaView
        ? parseInt(USER_ID())
        : adminView
          ? ""
          : parseInt(USER_ID()),
      organizationId: ORG_ID(),
      page: 1,
      pageSize: newPazeSize,
      cartType: cart,
      isTeamTask: isteam,
      search: search ? search : "",
    };
    swDashboardcardDetail(data);
  };
  useEffect(() => {
    if (isSearchInitial.current) {
      isSearchInitial.current = false;
      return;
    }
    if (debouncedSearch !== "") {
      handleSearch(debouncedSearch);
    } else {
      handleSearch("");
    }
  }, [debouncedSearch]);

  const handleautoSearch = (event) => {
    const value = event.target.value;
    setSearch(value);
  };

  const handleSearch = (searchText) => {
    setisTableLoading(true);
    setTimeout(() => setisTableLoading(false), 1);
    setPage(0);

    const data = {
      userId: areaView
        ? parseInt(USER_ID())
        : adminView
          ? ""
          : parseInt(USER_ID()),
      organizationId: ORG_ID(),
      page: 1,
      pageSize,
      cartType: cart,
      isTeamTask: isteam,
      search: searchText || "",
    };
    swDashboardcardDetail(data);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);

    const data = {
      userId: areaView
        ? parseInt(USER_ID())
        : adminView
          ? ""
          : parseInt(USER_ID()),
      organizationId: ORG_ID(),
      page: newPage + 1,
      pageSize: pageSize,
      cartType: cart,
      isTeamTask: isteam,
      search: search ? search : "",
    };
    swDashboardcardDetail(data);
  };
  const cancelinspection = (e) => {
    setOpen(false);
  };

  const createNews = () => {
    if (InactiveClient()) return;
    navigate(ADMIN_ADD_NEWS);
  };
  const listNews = () => {
    navigate(ADMIN_LIST_NEWS);
  };
  const swTeamtabclick = (val) => {
    setisteamval("");
    setisteam(false);
    if (val === 2) {
      setisteam(true);
      setisteamval(2);
    } else {
      setisteam(false);
      setisteamval(1);
    }
  };
  const dataHeader = {
    isdashboard: true,
    menu: [
      {
        text: "My Tasks",
        isshow: checkPrivileges([136, 137]) ? true : false,
        id: 1,
      },
      {
        text: "Team Tasks",
        isshow: checkPrivileges([136, 137]) ? true : false,
        id: 2,
      },
    ],
  };

  const onClickOnScheduledInsp = () => {
    navigate(SW_INSPECTION_LIST, {
      state: {
        from: "dashboard",
      },
    });
  };

  return (
    <>
      {/* {IsLoadings && <Loader />} */}

      {openModal && (
        <DialogBox
          open={openModal}
          rows={[]}
          header={"Confirm Deletion"}
          deletehandle={deletehandle}
          handleCloseModal={() => setOpenModal(false)}
          content={"Are you sure you want to delete this report?"}
          view
        />
      )}

      <Popover
        open={open1}
        anchorEl={anchorEl}
        onClose={handleClose1}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          className: "sw_tool_paper",
          style: {
            border: "1px",
            borderRadius: "4px",
          },
        }}
      >
        <Box p={3} className="sw_tooltip">
          {selectedRow && (
            <>
              {selectedRow?.row?.inspectionTypeId === 1 ? (
                <>
                  <Typography variant="body2">
                    Last Rainfall Event Date:{" "}
                    {selectedRow?.row?.rfEventDatePrv
                      ? getFormatedDate(selectedRow?.row?.rfEventDatePrv)
                      : "N/A"}
                  </Typography>
                  <Typography variant="body2">
                    Last Rainfall Amount:{" "}
                    {selectedRow?.row?.rfEventAmtPrv
                      ? formatRainfallValue(selectedRow?.row?.rfEventAmtPrv)
                      : "N/A"}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography variant="body2">
                    Rainfall Event Amount:
                    {selectedRow?.row?.rfEventAmt
                      ? formatRainfallValue(selectedRow?.row?.rfEventAmt)
                      : "N/A"}
                  </Typography>
                  <Typography variant="body2">
                    Rainfall Event Duration:{" "}
                    {selectedRow?.row?.rfEventDuration
                      ? selectedRow?.row?.rfEventDuration
                      : "N/A"}
                  </Typography>
                  <Typography variant="body2">
                    Rainfall Event Date:{" "}
                    {selectedRow?.row?.rfEventDate
                      ? getFormatedDate(selectedRow?.row?.rfEventDate)
                      : "N/A"}
                  </Typography>
                  <Typography variant="body2">
                    Last Rainfall Event Date:{" "}
                    {selectedRow?.row?.rfEventDatePrv
                      ? getFormatedDate(selectedRow?.row?.rfEventDatePrv)
                      : "N/A"}
                  </Typography>
                  <Typography variant="body2">
                    Last Rainfall Amount:{" "}
                    {selectedRow?.row?.rfEventAmtPrv
                      ? formatRainfallValue(selectedRow?.row?.rfEventAmtPrv)
                      : "N/A"}
                  </Typography>
                </>
              )}
            </>
          )}
        </Box>
      </Popover>

      <section className="grid_main_sec">
        <div className="grid_main_body ">
          <div className="commingsoon">
            <div className="headingcustomige">
              <h1 className="heading">Dashboard</h1>
            </div>
            <Grid
              container
              className="swdashboard-header"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item>
                <SiteProjectHeader
                  dataHeader={dataHeader}
                  swTeamtabclickFun={swTeamtabclick}
                  isteam={isteam}
                  isteamval={isteamval}
                />
              </Grid>
              {(checkPrivileges([136, 137]) ||
                (checkPrivileges([138]) && checkPrivileges([17]))) && (
                <Grid item>
                  <Buttons
                    id="btnAddClient"
                    label={"View Scheduled Inspections"}
                    varientContained={true}
                    onClick={onClickOnScheduledInsp}
                  ></Buttons>
                </Grid>
              )}
            </Grid>

            <Grid container mt={5} className="todayInspection">
              {" "}
              <h1 className="heading">Today’s Inspections</h1>
            </Grid>

            <Dialog onClose={handleClose} open={open}>
              <div className="diologSwDashboard">
                <DialogContent lg={6} xs={12} sm={6} md={4}>
                  <div className="desc_box row_uniqSwDash">
                    <div className="table_style_ui_swDash">
                      <Grid item lg={6} xs={12} sm={12} md={6} mt={1}>
                        <FormControl fullWidth>
                          <FormLabels
                            label={
                              ismissedOrDiffer === 1
                                ? "Reason for Missed Deferral"
                                : "Reason for Deferral"
                            }
                            isRequired={false}
                          />
                          <SelectMenu
                            listData={regAgencyData || []}
                            value={deffswInsData?.deferralReasonId}
                            onchangehandler={(e) => {
                              setDeffswInsData({
                                ...deffswInsData,
                                deferralReasonId: parseInt(e.target.value),
                                comment: "",
                              });
                              setisReasondiff(false);
                            }}
                            placeholder="Please Select"
                            isError={isReasondiff}
                            errorMsg={
                              isReasondiff
                                ? "Selection is required for this field "
                                : ""
                            }
                          />
                        </FormControl>
                      </Grid>
                      {deffswInsData?.deferralReasonId == otherDroupdownKey && (
                        <Grid mt={3} spacing={2} lg={12} md={4}>
                          <FormLabels isRequired={false} />

                          <TextArea
                            name={"issuefound"}
                            value={deffswInsData?.comment}
                            onChange={(e) => {
                              setDeffswInsData({
                                ...deffswInsData,
                                comment: e.target.value,
                              });
                            }}
                            isError={false}
                          />
                        </Grid>
                      )}

                      <Grid container mt={3}>
                        <Grid item lg={6}>
                          <div className="swcancel">
                            <Button
                              varientText={true}
                              label="Cancel"
                              onClick={(e) => cancelinspection(e)}
                            />
                          </div>
                        </Grid>

                        <Grid item lg={6}>
                          <div className="swsave">
                            <Button
                              varientContained={true}
                              label={"Save"}
                              onClick={() => deferralSwInspectionSubmit()}
                            />
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </DialogContent>
              </div>
            </Dialog>

            <Grid
              container
              lg={12}
              xs={12}
              sm={12}
              md={12}
              className="swdashboardBody"
            >
              {CHECK_PRE && (
                <>
                  <Grid item lg={2.7} xs={5.7} sm={5.7} md={2.7}>
                    <div
                      className={`dashboardCardBody  ${
                        cart === 1 ? "selected" : ""
                      }`}
                      onClick={() => {
                        inspectionduedashboard(1);
                      }}
                    >
                      <div className="icon">
                        <svg
                          width="23"
                          height="26"
                          viewBox="0 0 23 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.5 25.4961C1.8125 25.4961 1.22375 25.2515 0.73375 24.7623C0.244583 24.2723 0 23.6836 0 22.9961V5.49609C0 4.80859 0.244583 4.21984 0.73375 3.72984C1.22375 3.24068 1.8125 2.99609 2.5 2.99609H7.75C8.02083 2.24609 8.47417 1.64193 9.11 1.18359C9.745 0.72526 10.4583 0.496094 11.25 0.496094C12.0417 0.496094 12.7554 0.72526 13.3913 1.18359C14.0263 1.64193 14.4792 2.24609 14.75 2.99609H20C20.6875 2.99609 21.2763 3.24068 21.7663 3.72984C22.2554 4.21984 22.5 4.80859 22.5 5.49609V22.9961C22.5 23.6836 22.2554 24.2723 21.7663 24.7623C21.2763 25.2515 20.6875 25.4961 20 25.4961H2.5ZM2.5 22.9961H20V5.49609H2.5V22.9961ZM5 20.4961H13.75V17.9961H5V20.4961ZM5 15.4961H17.5V12.9961H5V15.4961ZM5 10.4961H17.5V7.99609H5V10.4961ZM11.25 4.55859C11.5208 4.55859 11.745 4.46984 11.9225 4.29234C12.0992 4.11568 12.1875 3.89193 12.1875 3.62109C12.1875 3.35026 12.0992 3.12609 11.9225 2.94859C11.745 2.77193 11.5208 2.68359 11.25 2.68359C10.9792 2.68359 10.7554 2.77193 10.5788 2.94859C10.4013 3.12609 10.3125 3.35026 10.3125 3.62109C10.3125 3.89193 10.4013 4.11568 10.5788 4.29234C10.7554 4.46984 10.9792 4.55859 11.25 4.55859Z"
                            fill="#666666"
                          />
                        </svg>
                      </div>
                      <div className="text">Inspections Due</div>
                      <div className="number">
                        {todayInspectionCount ? todayInspectionCount : 0}
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={2.7} xs={5.7} sm={5.7} md={2.7}>
                    <div
                      className={`dashboardCardBody  ${
                        cart === 2 ? "selected" : ""
                      }`}
                      onClick={() => {
                        inspectionduedashboard(2);
                      }}
                    >
                      <div className="icon">
                        <svg
                          width="23"
                          height="26"
                          viewBox="0 0 23 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.5 25.4961C1.8125 25.4961 1.22375 25.2515 0.73375 24.7623C0.244583 24.2723 0 23.6836 0 22.9961V5.49609C0 4.80859 0.244583 4.21984 0.73375 3.72984C1.22375 3.24068 1.8125 2.99609 2.5 2.99609H7.75C8.02083 2.24609 8.47417 1.64193 9.11 1.18359C9.745 0.72526 10.4583 0.496094 11.25 0.496094C12.0417 0.496094 12.7554 0.72526 13.3913 1.18359C14.0263 1.64193 14.4792 2.24609 14.75 2.99609H20C20.6875 2.99609 21.2763 3.24068 21.7663 3.72984C22.2554 4.21984 22.5 4.80859 22.5 5.49609V22.9961C22.5 23.6836 22.2554 24.2723 21.7663 24.7623C21.2763 25.2515 20.6875 25.4961 20 25.4961H2.5ZM2.5 22.9961H20V5.49609H2.5V22.9961ZM5 20.4961H13.75V17.9961H5V20.4961ZM5 15.4961H17.5V12.9961H5V15.4961ZM5 10.4961H17.5V7.99609H5V10.4961ZM11.25 4.55859C11.5208 4.55859 11.745 4.46984 11.9225 4.29234C12.0992 4.11568 12.1875 3.89193 12.1875 3.62109C12.1875 3.35026 12.0992 3.12609 11.9225 2.94859C11.745 2.77193 11.5208 2.68359 11.25 2.68359C10.9792 2.68359 10.7554 2.77193 10.5788 2.94859C10.4013 3.12609 10.3125 3.35026 10.3125 3.62109C10.3125 3.89193 10.4013 4.11568 10.5788 4.29234C10.7554 4.46984 10.9792 4.55859 11.25 4.55859Z"
                            fill="#666666"
                          />
                        </svg>
                      </div>
                      <div className="text">Past Due Inspections</div>
                      <div className="number resourse">
                        {pastDueinspectionCount ? pastDueinspectionCount : 0}
                      </div>
                    </div>
                  </Grid>
                </>
              )}
              <Grid item lg={2.7} xs={5.7} sm={5.7} md={2.7}>
                <div
                  className={`dashboardCardBody  ${
                    cart === 3 ? "selected" : ""
                  }`}
                  onClick={() => {
                    inspectionduedashboard(3);
                  }}
                >
                  <div className="icon">
                    <svg
                      width="23"
                      height="26"
                      viewBox="0 0 23 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.5 25.4961C1.8125 25.4961 1.22375 25.2515 0.73375 24.7623C0.244583 24.2723 0 23.6836 0 22.9961V5.49609C0 4.80859 0.244583 4.21984 0.73375 3.72984C1.22375 3.24068 1.8125 2.99609 2.5 2.99609H7.75C8.02083 2.24609 8.47417 1.64193 9.11 1.18359C9.745 0.72526 10.4583 0.496094 11.25 0.496094C12.0417 0.496094 12.7554 0.72526 13.3913 1.18359C14.0263 1.64193 14.4792 2.24609 14.75 2.99609H20C20.6875 2.99609 21.2763 3.24068 21.7663 3.72984C22.2554 4.21984 22.5 4.80859 22.5 5.49609V22.9961C22.5 23.6836 22.2554 24.2723 21.7663 24.7623C21.2763 25.2515 20.6875 25.4961 20 25.4961H2.5ZM2.5 22.9961H20V5.49609H2.5V22.9961ZM5 20.4961H13.75V17.9961H5V20.4961ZM5 15.4961H17.5V12.9961H5V15.4961ZM5 10.4961H17.5V7.99609H5V10.4961ZM11.25 4.55859C11.5208 4.55859 11.745 4.46984 11.9225 4.29234C12.0992 4.11568 12.1875 3.89193 12.1875 3.62109C12.1875 3.35026 12.0992 3.12609 11.9225 2.94859C11.745 2.77193 11.5208 2.68359 11.25 2.68359C10.9792 2.68359 10.7554 2.77193 10.5788 2.94859C10.4013 3.12609 10.3125 3.35026 10.3125 3.62109C10.3125 3.89193 10.4013 4.11568 10.5788 4.29234C10.7554 4.46984 10.9792 4.55859 11.25 4.55859Z"
                        fill="#666666"
                      />
                    </svg>
                  </div>
                  <div className="text">Drafts</div>
                  <div className="number draft">
                    {draftCount ? draftCount : 0}
                  </div>
                </div>
              </Grid>
              <Grid item lg={2.7} xs={5.7} sm={5.7} md={2.7}>
                <div
                  className="dashboardCardBody"
                  onClick={() => {
                    navigate(SW_OPEN_ITEMS, {
                      state: {
                        userId: areaView
                          ? parseInt(USER_ID())
                          : adminView
                            ? ""
                            : parseInt(USER_ID()),
                        isTeamTask: checkPrivileges([136, 137]) && isteam,
                      },
                    });
                  }}
                >
                  <div className="icon">
                    <svg
                      width="23"
                      height="26"
                      viewBox="0 0 23 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.5 25.4961C1.8125 25.4961 1.22375 25.2515 0.73375 24.7623C0.244583 24.2723 0 23.6836 0 22.9961V5.49609C0 4.80859 0.244583 4.21984 0.73375 3.72984C1.22375 3.24068 1.8125 2.99609 2.5 2.99609H7.75C8.02083 2.24609 8.47417 1.64193 9.11 1.18359C9.745 0.72526 10.4583 0.496094 11.25 0.496094C12.0417 0.496094 12.7554 0.72526 13.3913 1.18359C14.0263 1.64193 14.4792 2.24609 14.75 2.99609H20C20.6875 2.99609 21.2763 3.24068 21.7663 3.72984C22.2554 4.21984 22.5 4.80859 22.5 5.49609V22.9961C22.5 23.6836 22.2554 24.2723 21.7663 24.7623C21.2763 25.2515 20.6875 25.4961 20 25.4961H2.5ZM2.5 22.9961H20V5.49609H2.5V22.9961ZM5 20.4961H13.75V17.9961H5V20.4961ZM5 15.4961H17.5V12.9961H5V15.4961ZM5 10.4961H17.5V7.99609H5V10.4961ZM11.25 4.55859C11.5208 4.55859 11.745 4.46984 11.9225 4.29234C12.0992 4.11568 12.1875 3.89193 12.1875 3.62109C12.1875 3.35026 12.0992 3.12609 11.9225 2.94859C11.745 2.77193 11.5208 2.68359 11.25 2.68359C10.9792 2.68359 10.7554 2.77193 10.5788 2.94859C10.4013 3.12609 10.3125 3.35026 10.3125 3.62109C10.3125 3.89193 10.4013 4.11568 10.5788 4.29234C10.7554 4.46984 10.9792 4.55859 11.25 4.55859Z"
                        fill="#666666"
                      />
                    </svg>
                  </div>
                  <div className="text">Open Items</div>
                  <div className="number openitem">
                    {openItemCount ? openItemCount : 0}
                  </div>
                </div>
              </Grid>
            </Grid>

            <div className="div-filter-container">
              <div className="filter_of_caselist">
                <div className="searchcaseid">
                  <label htmlFor="search">
                    <span>
                      <SearchIcon />
                    </span>
                    <div>
                      <input
                        id="search"
                        placeholder="Search"
                        type="text"
                        value={search}
                        className=""
                        onChange={handleautoSearch}
                        autoComplete="off"
                      />
                    </div>
                  </label>
                </div>
              </div>
            </div>
            {isTableLoading ? (
              ""
            ) : (
              <div className="desc_box row_uniq ">
                <div className="table_style_ui ">
                  <GridTable
                    getRowId={(r) => r?.reportId}
                    rows={DashboardcarddetailsData?.listDetails ?? []}
                    rowCount={
                      cart === 1
                        ? todayInspectionCount
                        : cart === 2
                          ? pastDueinspectionCount
                          : cart === 3
                            ? draftCount
                            : openItemCount
                    }
                    columns={columns}
                    loading={
                      deffInspecrtion_Isloading ||
                      IsLoadings ||
                      deleteReportLoading
                    }
                    checkboxSelection={false}
                    page={page}
                    pagination
                    pageSize={pageSize}
                    rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                    onPageSizeChange={handlePageSizeChange}
                    onPageChange={handlePagignation}
                    backIconButtonProps={{ disabled: false }}
                    disableSelectionOnClick
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                    RowClassName={getRowClassName}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <Grid mt={3}>
          <div className="headingcustomigeCreateNews">
            {checkPrivileges([12, 87, 88]) && (
              <>
                <h1 className="heading1">Trending News</h1>

                <div onClick={createNews} className="customizedash">
                  <p>Create News/Announcement</p>
                  <img src={customizeDashIcon} alt="Customize Icon"></img>
                </div>
              </>
            )}
          </div>
          {checkPrivileges([12, 87, 88, 89]) && (
            <Suspense fallback={<div>please wait.....</div>}>
              <NewsList NewsData={NewsData} />
            </Suspense>
          )}

          {checkPrivileges([12, 87, 88, 89]) && (
            <Grid container item justifyContent="right" lg={12} mt={5}>
              <div className="seeall" onClick={listNews}>
                <p>See All</p>
              </div>
            </Grid>
          )}
        </Grid>
      </section>
      <ToastContainer />
    </>
  );
};

export default SwDashboard;
